import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { NavigationLink } from '..';

// Note, unlike NavigationMenuGroup this will only show
// active on an exact path match

const propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  // Sized like a NavigationMenuGroup
  large: PropTypes.bool,
};
const defaultProps = {
  large: false,
};


function NavigationMenuItem({ href, children, large }) {
  return (
    <div>
      <Route path={href} exact>
        {({ match }) => (
          <NavigationLink href={href} match={!!match} large={large}>
            {children}
          </NavigationLink>
        )}
      </Route>
    </div>
  );
}

NavigationMenuItem.propTypes = propTypes;
NavigationMenuItem.defaultProps = defaultProps;
export default NavigationMenuItem;
